import { render } from "./FZLC.vue?vue&type=template&id=d8f0fb82"
import script from "./FZLC.vue?vue&type=script&lang=js"
export * from "./FZLC.vue?vue&type=script&lang=js"

import "./FZLC.vue?vue&type=style&index=0&id=d8f0fb82&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__